import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LanguageService } from '../../../../core/services/language.service';
import { DialogModel } from '../../../../shared/components/dialog/dialog';
import { DIALOG_SIZE_COMPACT } from '../../../../shared/components/dialog/dialog-sizes';
import { LoopingConfirmationDialogComponent } from '../components/looping-confirmation-dialog/looping-confirmation-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class LearningPlanDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly languageService = inject(LanguageService);

  showDeleteLearningPlanDialog(onConfirm: () => void) {
    const deleteLearningPlanDialog = new DialogModel(this.dialog);
    deleteLearningPlanDialog.closable = true;
    deleteLearningPlanDialog.headline = this.languageService.translateOnRuntime(
      'portal.trainings.detailPage.deleteLearningPlanDialog.headline',
    );
    deleteLearningPlanDialog.description =
      this.languageService.translateOnRuntime(
        'portal.trainings.detailPage.deleteLearningPlanDialog.description',
      );

    deleteLearningPlanDialog.fourthDescription =
      this.languageService.translateOnRuntime(
        'portal.trainings.detailPage.deleteLearningPlanDialog.fourthDescription',
      );

    deleteLearningPlanDialog.fifthDescription =
      this.languageService.translateOnRuntime(
        'portal.trainings.detailPage.deleteLearningPlanDialog.fifthDescription',
      );

    deleteLearningPlanDialog.sixthDescription =
      this.languageService.translateOnRuntime(
        'portal.trainings.detailPage.deleteLearningPlanDialog.sixthDescription',
      );

    deleteLearningPlanDialog.buttonRowData = {
      confirmButtonText: this.languageService.translateOnRuntime(
        'portal.trainings.detailPage.deleteLearningPlanDialog.confirmButtonText',
      ),
      confirmButtonAction: onConfirm,
      declineButtonText:
        this.languageService.translateOnRuntime('general.abort'),
    };

    deleteLearningPlanDialog.openDialog();
    return deleteLearningPlanDialog;
  }

  showLoopingConfirmationDialog(isEnabling: boolean, onConfirm: () => void) {
    return this.dialog.open(LoopingConfirmationDialogComponent, {
      ...DIALOG_SIZE_COMPACT,
      autoFocus: false,
      data: {
        isEnabling,
        onConfirm,
      },
    });
  }
}
